'use strict';

var React = require('react');
var Border = require('../common/Border');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
var appTypes = require('../../types/appTypes');
var propConst = require('../../constants/propConst');
var ColorImage = require('../common/ColorImage');

var SearchBox = React.createClass({
  render: function () {
    var h = styleHelper.getHeight(this.props);
    var state = styleHelper.getPropertyValue(this.props, propConst.STATE);
    if(!state){
      state = this.props.state;
    }
    var isDisable = state === appTypes.ComStatus1.DISABLED;
    var imgStyle = {
      position: 'absolute',
      top: h / 2 - 8,
      width: 16,
      height: 16,
      whiteSpace: 'nowrap'
    };

    //var editable = false;
    var borderStyle = styleHelper.StyleUtil(this.props).background().size().border().text().lineHeight().align().base().style;
    var inputStyle = {};
    styleHelper.StyleUtil(this.props, inputStyle).align().text().background();
    if(this.props.textDirection === 'tdLeft') {
      imgStyle.right = 8;
      inputStyle.paddingLeft = 8 + parseInt(inputStyle.fontSize/3, 10) || 5;
    } else {
      imgStyle.left = 8;
      inputStyle.paddingLeft = 24 + parseInt(inputStyle.fontSize/3, 10) || 5;
    }
    inputStyle.width = parseInt(this.props.w, 10) - 24 - borderStyle.borderRadius - 2*(parseInt(inputStyle.fontSize/3, 10) || 5);
    if(isDisable){
      borderStyle.color = borderStyle.borderColor = appTypes.Color.MODEL_DISABLE;
      var rgba = util.Color.toRGBA(inputStyle.color);
      rgba.a *= 0.4;
      inputStyle.color = util.Color.rgbaToString(rgba);
    }

    return (<div className="border" style={borderStyle}>
      <ColorImage style={imgStyle}
                  color={isDisable?appTypes.Color.MODEL_DISABLE:styleHelper.getBorderColor(this.props)}
           src={assetsHelper.getComponentAsset('Search')}
      />
      <input
        type="text"
        defaultValue={styleHelper.getText(this.props)}
        style={inputStyle}

      />
    </div>);
  }
});

module.exports = SearchBox;



// WEBPACK FOOTER //
// ./src/views/Components/SearchBox.jsx